import {memo, ReactNode} from 'react';
import styled from 'styled-components';
import {MOBILE_BREAKPOINT} from './constants';

interface CardActionButtonsProps {
  children: ReactNode;
}

export const CardActionButtons = memo(({children}: CardActionButtonsProps) => {
  return (
    <ButtonsWrapper
      onClick={e => {
        e.stopPropagation();
      }}>
      {children}
    </ButtonsWrapper>
  );
});

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  /* Hide on mobile */
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: none;
  }
`;
